import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { DATA_GA_ID_KEY, DATA_GA_NAME_KEY } from './gaConstants';
import styles from './HpRespShopByModuleItem.scss';
import { slugify } from '../../utils/slugify';
import { SeoLink } from 'dibs-seo/exports/SeoLink';

function HpRespShopByModuleItem({ item, gaDataAttrs, className, isTopRow, onClick }) {
    const classNames = classnames(
        styles.wrapper,
        {
            [styles.topRow]: isTopRow,
            [styles.bottomRow]: !isTopRow,
        },
        className
    );

    if (!item.title || !item.linkData.path) {
        return null;
    }

    return (
        <div className={classNames} {...gaDataAttrs} data-tn={slugify(item.title)}>
            <SeoLink linkData={item.linkData} className={styles.link} onClick={onClick}>
                <div
                    className={styles.background}
                    style={{ backgroundImage: `url(${item.imageUrl})` }}
                >
                    <span className={styles.title}>{item.title}</span>
                </div>
            </SeoLink>
        </div>
    );
}

HpRespShopByModuleItem.propTypes = {
    item: PropTypes.shape({
        title: PropTypes.string,
        imageUrl: PropTypes.string,
        linkData: PropTypes.object.isRequired,
    }).isRequired,
    gaDataAttrs: PropTypes.shape({
        [DATA_GA_ID_KEY]: PropTypes.string.isRequired,
        [DATA_GA_NAME_KEY]: PropTypes.string.isRequired,
    }),
    className: PropTypes.string,
    isTopRow: PropTypes.bool,
    onClick: PropTypes.func,
};

HpRespShopByModuleItem.defaultProps = {
    onClick: () => {},
};

export { HpRespShopByModuleItem };
